import { View } from 'react-native';
import styles from '../Styles';
import FadeIn from './FadeIn';
import ThrobbingButton from './ThrobbingButton';

const ContentItemsListCompleteButton = (props) => {
  const pressedButton = () => {
    props.tappedButton();
  };

  if (props.visible) {
    return (
      <FadeIn delay={2}
        growHeight={true}
        itemKey="itemsListComplete">
        <ThrobbingButton
          tappedButton={pressedButton}
          coverStyle={props.coverStyle || styles.startVoyageCover}
          buttonText={props.label || "Finished"}          
          skipIcon={props.skipIcon}    
          imagePath={require("../../assets/images/Wayfinding.png")} />
      </FadeIn>
    );
  } else {
    return (<View></View>);
  }
};

export default ContentItemsListCompleteButton;
